
/* injects from baggage-loader */

'use strict';

export default class AccountController {

	constructor($log, Upload) {
		'ngInject';

		this.$log = $log;
		this.Upload = Upload;

	}

	$onInit() {

		// this.$log.log(this.profile);

	}

	uploadProfileImage(file) {
		this.$log.log('Image detected!');
		this.$log.log(file)
	}

}



// WEBPACK FOOTER //
// ./src/app/pages/account/account.controller.js